import React from 'react';
import { Bone } from '../Bone/Bone';
import './SkillToolsSkeleton.css';

/** Skill tools while it loads: its empty state, an image and two lines, centered. */
export function SkillToolsSkeleton(): React.ReactElement {
  return (
    <div className="integrations-tools-skeleton">
      <Bone className="integrations-tools-skeleton__image" />
      <Bone className="integrations-tools-skeleton__title" />
      <Bone className="integrations-tools-skeleton__hint" />
      <Bone className="integrations-tools-skeleton__hint integrations-tools-skeleton__hint--phone" />
    </div>
  );
}
